import { all } from 'redux-saga/effects';
import { authSaga } from '../../features/auth/ducks';
import { accountSaga } from '../../features/account-management/ducks';
import { dashboardSaga } from '../../features/admin-dashboard/ducks';
import { filesSaga } from '../../features/files/ducks';
import { loanSaga } from '../../features/loan-management/ducks';
import { allocationsSaga } from '../../features/allocations/ducks';
import { disposalsSaga } from '../../features/disposals/ducks';
import { loansSaga } from '../../features/loans/ducks';
import { documentsSaga } from '../../features/documents/ducks';
import { allocationSaga } from '../../features/allocation-management/ducks';
import { paymentSaga } from '../../features/payment-management/ducks';
import { messagingSaga } from '../../features/messaging-dashboard/ducks';
import { settingSaga } from '../../features/setting-management/ducks';
import { landingPageSaga } from '../../features/landing-page/ducks';
import { paymentsSaga } from '../../features/payments/ducks';
import { transactionSaga } from '../../features/transactions/ducks';
import { overviewSaga } from '../../features/overview/ducks'
import { questionSaga } from '../../features/help-management/ducks';
import { penaltyFeesSaga } from '../../features/penalty-fee/ducks';
import { psd2Saga } from '../../features/psd2/ducks';

export default function* rootSaga() {
  yield all([
    authSaga(),
    accountSaga(),
    dashboardSaga(),
    filesSaga(),
    loanSaga(),
    allocationsSaga(),
    disposalsSaga(),
    loansSaga(),
    documentsSaga(),
    allocationSaga(),
    landingPageSaga(),
    paymentSaga(),
    messagingSaga(),
    settingSaga(),
    paymentsSaga(),
    transactionSaga(),
    questionSaga(),
    overviewSaga(),
    penaltyFeesSaga(),
    psd2Saga(),
  ]);
}



// WEBPACK FOOTER //
// ./src/app/store/rootSaga.js